import React from "react";
import PropTypes from "prop-types";
import PersonIcon from "@material-ui/icons/Person";
import RoomIcon from "@material-ui/icons/Room";
import { toDisplayDate } from "../../../../../domain/professionalContacts/professionalContacts.rules";
import { LOAN_ROLE_DATE_FIELDS } from "../../../../../domain/professionalContacts/professionalContacts.types";
import useStyles from "./ProfessionalDetails.styles";

const formatAddress = (address) =>
  address ? [address.building, address.street, address.town, address.postcode].filter(Boolean).join(", ") : null;

/**
 * One role's read-only line on the Professional Details screen (§4b): firm, selected
 * individual (number + email), selected address, and role dates (dd/mm/yyyy).
 */
const RoleReadCard = ({ roleKey, label, assignment, firm }) => {
  const classes = useStyles();
  const contact = firm?.contacts?.find((c) => c.id === assignment.contactId) || null;
  const address = firm?.addresses?.find((a) => a.id === assignment.addressId) || null;
  const dateFields = LOAN_ROLE_DATE_FIELDS[roleKey] || [];

  return (
    <div className={classes.roleCard}>
      <div className={classes.roleCardHead}>
        <b>{label}</b>
        <span className={classes.subtle}>
          {firm ? firm.name : "-"}
          {contact ? ` · ${contact.name}` : ""}
        </span>
      </div>
      {dateFields.length > 0 && (
        <div className={classes.roleDates}>
          {dateFields.map(({ key, label: dateLabel }) => (
            <span key={key} className={classes.subtle}>
              {dateLabel.replace(/^Date /, "")}: <span style={{ color: "var(--color-text-primary)" }}>{toDisplayDate(assignment.dates?.[key]) || "-"}</span>
            </span>
          ))}
        </div>
      )}
      {contact && (
        <div className={classes.subtle} style={{ marginTop: 2 }}>
          <PersonIcon fontSize="inherit" /> {contact.email} · {contact.phone}
        </div>
      )}
      {address && (
        <div className={classes.subtle} style={{ marginTop: 2 }}>
          <RoomIcon fontSize="inherit" /> {formatAddress(address)}
        </div>
      )}
    </div>
  );
};

RoleReadCard.propTypes = {
  roleKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  assignment: PropTypes.object.isRequired,
  firm: PropTypes.object,
};

export default RoleReadCard;
